const styles = (theme) => ({
  value: {
    textTransform: 'uppercase',
    color: theme.colors.light_text
  }
});

export default styles;
